import React from 'react';

import * as Styled from './completed.style';
import { CompletedTasksList } from './components/completed-tasks-list';
import { PageTopBar } from './components/page-top-bar';

export const Completed: React.FC = () => {
  return (
    <Styled.Container>
      <Styled.Main>
        <Styled.MainContent>
          <PageTopBar />

          <Styled.Content>
            <CompletedTasksList />
          </Styled.Content>
        </Styled.MainContent>
      </Styled.Main>
    </Styled.Container>
  );
};
